import React, { useEffect } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import PropTypes from 'prop-types';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import {
  storeCodeOutletMapping,
  storeCodes
} from '../../../../../registration/constant';

const StoreCode = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  useEffect(() => {
    return () => {
      setFieldData(previousValue => ({ ...previousValue, storeCode: '' }));
    };
  }, []);

  const getMappedOutletId = storeCodeValue => {
    return storeCodeOutletMapping[storeCodeValue] || null;
  };

  return (
    <>
      <div
        className="main-content-form-headers"
        style={{ marginBottom: '2px' }}
      >
        <span className="select-placeholder">Store Code (Home Store) *</span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${formErrors.storeCode ? 'error' : ''}`}
      >
        <Typeahead
          id="storeCode"
          labelKey="label"
          options={storeCodes}
          onChange={selected => {
            const selectedCode = selected[0] || '';
            if (!selectedCode) {
              setFormErrors({
                ...formErrors,
                storeCode: { message: 'Field is required' }
              });
            } else {
              const errors = { ...formErrors };
              delete errors.storeCode;
              setFormErrors({
                ...errors
              });
            }
            setFieldData(previousValue => ({
              ...previousValue,
              storeCode: selectedCode
            }));
            const mappedOutlet = getMappedOutletId(selectedCode);
            if (mappedOutlet) {
              setFieldData(previousValue => ({
                ...previousValue,
                outlet: mappedOutlet
              }));
            }
          }}
          placeholder="Store Code"
          selected={fieldData.storeCode ? [fieldData.storeCode] : []}
          clearButton
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">
              {formErrors.storeCode ? formErrors.storeCode.message : ''}
            </span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>
    </>
  );
};

StoreCode.propTypes = {
  formErrors: PropTypes.shape({
    storeCode: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default StoreCode;
